<template>
  <div class="card shadow">
    <div class="card-header">
      <div class="row align-items-center">
        <div class="col-6">
          Distributors
        </div>
        <div class="col-6">
          <distributor-create v-if="$store.getters.isAdmin" />
        </div>
      </div>
    </div>
    <div v-loading="loading">
      <table class="table">
        <thead class="thead-light">
          <tr>
            <th>Name</th>
            <th v-if="$store.getters.isAdmin">Operations</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="distributor in distributors" :key="distributor.id">
            <td><router-link :to="{ name: 'distributors-id', params: { id: distributor.id } }">{{ distributor.name }}</router-link></td>
            <td v-if="$store.getters.isAdmin">
              <distributor-delete :distributorId="distributor.id" @delete="$emit('update')" />
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import DistributorCreate from '@/components/Distributor/DistributorCreate'
import DistributorDelete from '@/components/Distributor/DistributorDelete'

export default {
  components: {
    DistributorCreate,
    DistributorDelete,
  },

  data() {
    return {
      loading: true,
      distributors: [],
    }
  },

  mounted() {
    this.getDistributors()
  },

  methods: {
    async getDistributors() {
      try {
        var { data } = await this.$http.get(`/distributors`)
      } catch(err) {
        this.$message.error(err.response.data.message)
        return false
      } finally {
        this.loading = false
      }

      this.distributors = data
    },
  },
}
</script>
